import type { SearchResult } from "../../../api";
import { EmptyState } from "../common/reader-widgets";
import { SearchResultCard } from "./search-result-card";

export function SearchResultList({
  emptyText,
  results,
  onSelect,
}: {
  emptyText: string;
  results: SearchResult[];
  onSelect: (bookId: string) => void;
}) {
  if (results.length === 0) {
    return <EmptyState text={emptyText} />;
  }

  return (
    <div className="grid gap-3">
      {results.map((result, index) => (
        <SearchResultCard
          key={result.book.id}
          title={result.book.title}
          author={result.book.author}
          coverUrl={result.book.coverUrl}
          tags={result.book.tags}
          description={result.book.description}
          sourceCount={result.sources.length}
          latestChapterTitle={result.sources[0]?.latestChapterTitle}
          index={index}
          onClick={() => onSelect(result.book.id)}
        />
      ))}
    </div>
  );
}
